export const GET_ARTICLES = "GET_ARTICLES";
export const GET_ARTICLES_REQUEST = "GET_ARTICLES_REQUEST";
export const GET_ARTICLES_FAILED = "GET_ARTICLES_FAILED";

export const GET_VIDEOS = "GET_VIDEOS";
export const GET_VIDEOS_REQUEST = "GET_VIDEOS_REQUEST";
export const GET_VIDEOS_FAILED = "GET_VIDEOS_FAILED";

export const GET_AUDIO = "GET_AUDIO";
export const GET_AUDIO_REQUEST = "GET_AUDIO_REQUEST";
export const GET_AUDIO_FAILED = "GET_AUDIO_FAILED";

export const GET_CRYPTO_STATS = "GET_CRYPTO_STATS";
export const GET_CRYPTO_STATS_REQUEST = "GET_CRYPTO_STATS_REQUEST";
export const GET_CRYPTO_STATS_FAILED = "GET_CRYPTO_STATS_FAILED";

export const GET_CRYPTO_DATA = "GET_CRYPTO_DATA";
export const GET_CRYPTO_DATA_REQUEST = "GET_CRYPTO_DATA_REQUEST";
export const GET_CRYPTO_DATA_FAILED = "GET_CRYPTO_DATA_FAILED";
